export default __webpack_public_path__ + "static/media/intro.d25c13ca.mp4";